module.exports = __webpack_public_path__ + "static/img/dg.b99ecf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dg.png
// module id = limb
// module chunks = 1